module.exports = __webpack_public_path__ + "static/media/transfer-in.7df3c2ce.svg";